import {
	connect
} from 'react-redux'
import AdvancedSearchComponent from '../components/AdvancedSearchComponent.jsx';
import {
	changeSearchEventKey,
	cleanSearchEpclList
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	eventKey: state.getIn(['searchReducer', 'eventKey'])
})

const mapDispatchToProps = (dispatch) => ({
	changeEventKey: (key) => {
		dispatch(changeSearchEventKey(key));
	},
	cleanSearchResult: () => {
		dispatch(cleanSearchEpclList());
	}
})

const AdvancedSearchContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(AdvancedSearchComponent)

export default AdvancedSearchContainer;


// WEBPACK FOOTER //
// ./src/containers/AdvancedSearchContainer.jsx